import { useState } from "react";
import { useAuth, API } from "../App";
import axios from "axios";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, Eye, EyeOff, Lock } from "lucide-react";
import { toast } from "sonner";

const ForceChangePassword = () => {
  const { user, token, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 4) {
      toast.error("كلمة المرور الجديدة يجب أن تكون 4 أحرف على الأقل");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("كلمة المرور الجديدة غير متطابقة");
      return;
    }
    setSubmitting(true);
    try {
      await axios.put(`${API}/auth/change-password`, {
        current_password: currentPassword,
        new_password: newPassword
      }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("تم تغيير كلمة المرور بنجاح — يرجى إعادة تسجيل الدخول");
      logout();
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل تغيير كلمة المرور");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#4a3fa8] to-[#655dc6] flex items-center justify-center p-4" dir="rtl">
      <Card className="w-full max-w-md border-0 shadow-xl" data-testid="force-change-password-card">
        <CardContent className="pt-8 pb-6 px-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-amber-600" />
            </div>
            <h1 className="text-xl font-bold text-[#655dc6] mb-2">تغيير كلمة المرور مطلوب</h1>
            <p className="text-sm text-slate-500">
              مرحباً {user?.full_name}، يجب تغيير كلمة المرور الخاصة بك قبل المتابعة
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label>كلمة المرور الحالية</Label>
              <div className="relative">
                <Input
                  type={showCurrent ? "text" : "password"}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="أدخل كلمة المرور الحالية"
                  className="text-left pl-10"
                  dir="ltr"
                  required
                  autoComplete="new-password"
                  data-testid="current-password-input"
                />
                <button type="button" onClick={() => setShowCurrent(!showCurrent)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                  {showCurrent ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <div className="space-y-2">
              <Label>كلمة المرور الجديدة</Label>
              <div className="relative">
                <Input
                  type={showNew ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="أدخل كلمة المرور الجديدة"
                  className="text-left pl-10"
                  dir="ltr"
                  required
                  autoComplete="new-password"
                  data-testid="new-password-input"
                />
                <button type="button" onClick={() => setShowNew(!showNew)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                  {showNew ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <div className="space-y-2">
              <Label>تأكيد كلمة المرور الجديدة</Label>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="أعد إدخال كلمة المرور الجديدة"
                className="text-left"
                dir="ltr"
                required
                autoComplete="new-password"
                data-testid="confirm-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#655dc6] hover:bg-[#5449a8] text-white mt-4"
              disabled={submitting}
              data-testid="submit-change-password-btn"
            >
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "تغيير كلمة المرور"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForceChangePassword;
